/** Maps DB / print-service boolean representations (0, 1, "0", "1") to actual booleans. */
export const zeroOneToBoolean = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === '0' || normalized === 'false') {
      return false;
    }
    if (normalized === '1' || normalized === 'true') {
      return true;
    }
    const numValue = Number(value);
    if (!Number.isNaN(numValue)) {
      return numValue === 1;
    }
  }

  return Boolean(value);
};
